module.exports = __webpack_public_path__ + "static/media/partiesInactive.11f03565.svg";